const $enrollTogetherInfo = $('[data-js-bind="enroll-together"]');
let recalcPositions;

function checkPopupPositions() {
  if (recalcPositions) cancelAnimationFrame(recalcPositions);
  recalcPositions = requestAnimationFrame(function() {
    for (let i = 0; i < $enrollTogetherInfo.length; i++) {
      const thisInfo = $enrollTogetherInfo[i];
      const thisPopup = thisInfo.querySelector('[data-js-bind="enroll-together-popup"]');
      const thisInfoBottom = thisInfo.getBoundingClientRect().bottom;
      const popupHeight = thisPopup.getBoundingClientRect().height;
      thisInfo.classList[thisInfoBottom + popupHeight >= window.innerHeight? 'add' : 'remove']('c-enroll-together--popup-top');
    }
  });
}

window.addEventListener('resize', checkPopupPositions);
window.addEventListener('scroll', checkPopupPositions);

checkPopupPositions();
